// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as AuthStore$PorterinFeature from "../../../login/domain/store/AuthStore.mjs";
import * as CookieHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CookieHelpers.mjs";
import * as CookieUtils$PorterinFeature from "../../utils/browser/CookieUtils.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as CategoryAnalytics$PorterinFeature from "./CategoryAnalytics.mjs";
import * as ExperimentsConfig$PorterinFeature from "../../../../shared/experiments/ExperimentsConfig.mjs";
import * as EventsTrackerHelper$PorterinFeature from "../../../../shared/core/helpers/EventsTrackerHelper.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../store/FareEstimateStoreV1.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as ExperimentsController$PorterinFeature from "../../../../shared/experiments/ExperimentsController.mjs";
import * as FareEstimateResultFormHelper$PorterinFeature from "../../../../shared/core/helpers/FareEstimateResultFormHelper.mjs";

var getFareSelectedCardVersion = ExperimentsController$PorterinFeature.getFareEstimateCardSelectedVersion;

function getFareSelectedCardVersionEventPayload(mobile) {
  return {
          WBF_TG_Version: ExperimentsConfig$PorterinFeature.FareSelectedCard.getFareSelectedCardEventValue(ExperimentsController$PorterinFeature.getFareEstimateCardSelectedVersion(mobile)),
          Web_tracking_id: CookieHelpers$PorterinUtils.webTrackingIdSafely(undefined),
          location_accuracy: FareEstimateStoreV1$PorterinFeature.location_accuracy_tg
        };
}

function isNewUserSignup(mobile) {
  Js_promise.$$catch((function (error) {
          Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, error.toString());
          return Promise.resolve(undefined);
        }), Js_promise.then_((function (customer_exist_flag) {
              if (customer_exist_flag !== undefined) {
                if (customer_exist_flag) {
                  
                } else {
                  EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.OtpValidation.ga_registration, {
                        fe_loginotp_registration_parameter: mobile
                      });
                }
              } else {
                EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.OtpValidation.ga_registration_failed, {
                      fe_loginotp_reg_check_failed_parameter: mobile
                    });
              }
              return Promise.resolve(undefined);
            }), FareEstimateResultFormHelper$PorterinFeature.getCustomerExistInfo(mobile)));
}

function errorModalRetryEvent(error_type, router, mobile) {
  var category = CategoryAnalytics$PorterinFeature.getCategoryName(router);
  switch (error_type) {
    case /* InvalidToken */0 :
        return PublishEventsHelper$PorterinFeature.publishEvents(category, FareEstimateStoreV1$PorterinFeature.ga_error_invalid_token_retry, undefined);
    case /* InvalidPickup */1 :
        return PublishEventsHelper$PorterinFeature.publishEvents(category, FareEstimateStoreV1$PorterinFeature.ga_error_invalid_pickup_retry, undefined);
    case /* InvalidDrop */2 :
        return PublishEventsHelper$PorterinFeature.publishEvents(category, FareEstimateStoreV1$PorterinFeature.ga_error_invalid_drop_retry, undefined);
    case /* FailedAPI */3 :
        PublishEventsHelper$PorterinFeature.publishEvents(category, FareEstimateStoreV1$PorterinFeature.ga_error_failed_api_retry, undefined);
        return EventsTrackerHelper$PorterinFeature.publishEventParameter(FareEstimateStoreV1$PorterinFeature.moe_error_failed_api_retry_parameter, getFareSelectedCardVersionEventPayload(mobile));
    case /* FailedCreateTrip */4 :
        PublishEventsHelper$PorterinFeature.publishEvents(category, FareEstimateStoreV1$PorterinFeature.ga_error_failed_create_trip_retry, undefined);
        return EventsTrackerHelper$PorterinFeature.publishEventParameter(FareEstimateStoreV1$PorterinFeature.moe_error_failed_create_trip_retry_parameter, getFareSelectedCardVersionEventPayload(mobile));
    
  }
}

function publishLocationAccuracyEvent($$event) {
  EventsTrackerHelper$PorterinFeature.publishEventParameter($$event, {
        Web_tracking_id: CookieUtils$PorterinFeature.webTrackingIdSafely(undefined),
        location_accuracy: FareEstimateStoreV1$PorterinFeature.location_accuracy_tg
      });
}

export {
  getFareSelectedCardVersion ,
  getFareSelectedCardVersionEventPayload ,
  isNewUserSignup ,
  errorModalRetryEvent ,
  publishLocationAccuracyEvent ,
}
/* CookieHelpers-PorterinUtils Not a pure module */
